export const GET_DATA_NEXT_MATCHES      = "GET_DATA_NEXT_MATCHES"
export const SHOW_MODAL_FORM_QUINELA    = "SHOW_MODAL_FORM_QUINELA"
export const SHOW_MODAL_STATISTICS_QUINELA    = "SHOW_MODAL_STATISTICS_QUINELA"
export const DATA_FORM_QUINELA          = "DATA_FORM_QUINELA"
export const DATA_STATISTICS_FORM_QUINELA          = "DATA_STATISTICS_FORM_QUINELA"